import { useCallback, useEffect, useState } from 'react'
import {
  defaultNavigationItems,
  getNavigationItems,
  saveNavigationItems,
  subscribeNavigationItems,
  type EditableNavigationItem,
} from '../data/navigationSettings'

export function useNavigationSettings() {
  const [items, setItems] = useState<EditableNavigationItem[]>(() => getNavigationItems())

  useEffect(() => subscribeNavigationItems(setItems), [])

  const saveItems = useCallback((nextItems: EditableNavigationItem[]) => {
    saveNavigationItems(nextItems)
    setItems(nextItems)
  }, [])

  const resetItems = useCallback(() => {
    saveNavigationItems(defaultNavigationItems)
    setItems(defaultNavigationItems)
  }, [])

  return { items, saveItems, resetItems }
}
